export default {
  root: {
    textTransform: 'none',
    fontWeight: 500
  }
};
